import { put, call, takeLatest } from "redux-saga/effects";
import {  RENAME_FOLDER, RENAME_FOLDER_API, USER_DISPLAY_MSG } from "../../../../Constants";
import apiService from "../../../utils/apiService";
import _ from 'lodash';


function renameFolderCall(payload)
{
    return apiService.post(RENAME_FOLDER_API,payload).then((response) => {
        return _.get(response,"data",{});
    }).catch(error => {
        return error.response.data;
    })
}

const renameFolder = function* (payload) {
    let response;
    try {
        response = yield call(renameFolderCall,payload.payload);

        if(_.get(response,"status_code",'') === 200 || _.get(response,"status_code",'') === 500)
        {
            yield put({ type : USER_DISPLAY_MSG, response});
        }
        
        return response;
    } catch (error) {

    }
}


function* RenameFolderSaga() {
    yield takeLatest(RENAME_FOLDER, renameFolder);
}


export default RenameFolderSaga;